export default "__VITE_ASSET__COaa9ODr__"